import { Type } from 'class-transformer';
import { GLJournalAttachmentRawDto } from './gl-journal-attachment-raw-dto';

export class JournalEntryAttachmentUpdateParametersDto {
    managementCompanyId: number;
    communityId: number;
    journalEntryId: number;
    @Type(() => GLJournalAttachmentRawDto)
    attachments: GLJournalAttachmentRawDto[];
}
